import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { SELLER_DISCOUNTS_STREAM } from '../../../../../constants';
import DiscountRowMobile from './DiscountRowMobile';
import Surface from '@wix/da-ds/pkg/Surface';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { Url } from '@wix/da-url';
import { useSelector } from 'react-redux';
import { getActiveSection } from '../../../../selectors/studio';
import { StudioSection } from '../../../../types/store';
import EmptyDiscountList from '../EmptyDiscountList';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';

import s from './SellerDiscountsMobile.scss';

interface Props {}

const SellerDiscountsMobile: FC<Props> = () => {
  const { t } = useTranslation();
  const activeSection = useSelector(getActiveSection);
  const { items: discounts } = useStream(SELLER_DISCOUNTS_STREAM.streamId);

  const isEmpty = discounts.length === 0;

  const isActiveAndScheduled =
    activeSection === StudioSection.SELLER_DISCOUNTS_ACTIVE_AND_SCHEDULED;

  if (isEmpty) {
    return <EmptyDiscountList />;
  }

  return (
    <ScrollableContent>
      <Surface
        className={s['root']}
        type={ThemeSurface.SECONDARY}
        themeOverrideOnly
      >
        {discounts.map(discount => (
          <DiscountRowMobile
            className={s['discount-row']}
            key={discount.discountId}
            discount={discount}
          />
        ))}
      </Surface>
      {
        <div className={s['past-discounts-bar']}>
          <TextButton
            size="medium"
            variant="main"
            href={Url.studio({
              section: 'discounts',
              discounts: isActiveAndScheduled
                ? 'ended'
                : 'active_and_scheduled',
            })}
          >
            {t(
              isActiveAndScheduled
                ? 'studio.discounts.viewPastDiscounts'
                : 'studio.discounts.viewActiveAndScheduledDiscounts'
            )}
          </TextButton>
        </div>
      }
    </ScrollableContent>
  );
};
SellerDiscountsMobile.displayName = 'SellerDiscountsMobile';

export default SellerDiscountsMobile;
